
import VueCookie from 'vue-cookie'
// Vue.use(VueCookie)

export default {
  name: 'language',
  data() {
    return {
    }
  },
  mounted() {
    // 根据cookie存储的语言信息设定语言
    const LANG = VueCookie.get('lang')
    if (LANG) {
      this.$i18n.locale = LANG
    }

    // 当前页面应该使用的语言填入语言选择框
    if (this.$i18n.locale === 'en') {
      this.$refs.choose.style.left = '40px'
    }
  },
  methods: {
    setZh() {
      if (this.$i18n.locale !== 'zh') {
        this.setLang('zh')
        this.$refs.choose.style.left = '0'
      }
    },
    setEn() {
      if (this.$i18n.locale !== 'en') {
        this.setLang('en')
        this.$refs.choose.style.left = '40px'
      }
    },
    // getLang() {
    //   // 获取系统语言
    //   const myLang = this.getSysLang()
    //   //
    //   this.$i18n.locale = myLang
    //   if (myLang === 'zh') {
    //     this.$Notice.success({
    //       title: '温馨提示',
    //       desc: '首次登录，我们已将网站语言设置为系统语言。您可以点击语言栏切换。'
    //     });
    //   } else {
    //     this.$Notice.success({
    //       title: 'Notice',
    //       desc: 'We have already set your Language to US English, You can change it later.'
    //     });
    //   }
    // },
    setLang(e) {
      // 用户设置语言
      this.$i18n.locale = e
      console.log('ready to set cookie language', e)
      VueCookie.delete('lang')
      VueCookie.set('lang', e, { domain: '.gecacademy.cn' })
      console.log(VueCookie.get('lang'))
    }
    // getSysLang () {
    //   let language = '';
    //   if (navigator.appName === 'Netscape') {
    //     language = navigator.language;
    //   } else {
    //     language = navigator.browserLanguage;
    //   }
    //   // 获取到系统语言，对语言进行整理
    //   if (language === 'zh' || language === 'zh-CN'|| language === 'zh-TW'|| language === 'zh-HK') {
    //     return 'zh';
    //   } else {
    //     // 其他语言统一使用美式英语
    //     return 'en';
    //   }
    // }
  }
}



// WEBPACK FOOTER //
// ./src/components/language/language.js